if (!customElements.get('ggp-sticky-atc')) {
  customElements.define(
    'ggp-sticky-atc',
    class GgpStickyAtc extends HTMLElement {
      constructor() {
        super();
        this.anchor = null;
        this.observer = null;
      }

      connectedCallback() {
        if (window.matchMedia('(min-width: 750px)').matches) return;

        // Reveal the bar once the main buy button has scrolled out of view.
        this.anchor = document.querySelector('.product-form__submit, .product-form__buttons');
        if (!this.anchor || !('IntersectionObserver' in window)) {
          this.show();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.hide();
              } else if (entry.boundingClientRect.top < 0) {
                this.show();
              } else {
                this.hide();
              }
            });
          },
          { rootMargin: '0px 0px -100% 0px' }
        );

        this.observer.observe(this.anchor);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      show() {
        this.classList.add('is-visible');
        this.setAttribute('aria-hidden', 'false');
      }

      hide() {
        this.classList.remove('is-visible');
        this.setAttribute('aria-hidden', 'true');
      }
    }
  );
}
